import * as BOOK from './config/book'

/**
 * 预约挂号模块相关配置
 * @type {{level?}}
 */
export const BOOK_COBFIG = BOOK

export const APP_NAME = 'sdyk_'

/**
 * 基础参数
 * @type {{channel: string, format: string, oper: string, random: string, spid: string}}
 */
export const BASE_PARAMS = {
  'channel': '31',
  'format': 'JSON',
  'oper': '127.0.0.1',
  'random': '1234',
  'spid': '1001'
}
/**
 * MD5签名
 * @type {string}
 */
export const MD5_PASSWORD = 'aAr9MVS9j1'

/**
 * cardType
 * @type {*[]}
 */
export const CardType = [
  {text: '注册医疗卡', value: '01'},
  {text: '医保卡', value: '04'},
  {text: '省保一卡通', value: '11'}
]

/**
 *
 * @type {string}
 */
export const HOSID = '3700000001' // 平台医院id
export const HosName = '山东中医药大学附属眼科医院' //医院名称
export const OnlineHosid = '053101' // his医院id  标准版057103  深圳075501
export const PayStyle = 'weixinPay' //weixinPay直接唤起微信支付，yidianPay跳转到第三方支付
export const docAva = '//api.semeye.com/docPic/' // his医院id
/* 微信定位用到的火星定位 */
export const Hos_Lon = 116.998750 //医院经度 火星坐标
export const Hos_Lat = 36.631829 //医院纬度 火星坐标

/* 百度地图用到的定位 */
// export const Hos_Lon = 117.005125 //医院经度 火星坐标
// export const Hos_Lat = 36.638172 //医院纬度 火星坐标


// export const Hos_Lon = 120.208651 //测试经度 火星坐标 公司地址
// export const Hos_Lat = 30.262563 //测试纬度 火星坐标 公司地址

export const navButton = [
  {name: '预约记录', imgUrl: 'static/img/online/book-record.png', router: '/my/order/list'},
  //{name: '处方检查', imgUrl: 'static/img/online/prescription.png', router: '/bind/switch-patient?type=invoice&title=处方检查'},
  // {name: '我的处方', imgUrl: 'static/img/online/prescription.png', router: '/recipe/list/all'},
  {name: '个人中心', imgUrl: 'static/img/online/per-center.png', router: '/my'}
]

export const bookIcon = [
  {name: 'count-icon', iconUrl: 'static/img/book-item/count-icon.png'},
  {name: 'video-icon', iconUrl: 'static/img/book-item/video-icon.png'}
]

export const relationShip = ['本人', '父母', '配偶', '子女', '亲戚', '朋友', '其他']

export const medicalinfo = [
  {type: 'presentingComplaint', name: '所患疾病'},
  {type: 'pastHistory', name: '既往史'},
  {type: 'familyHistory', name: '家族史'},
  {type: 'allergyHistory', name: '过敏史'}
]

export const medicalFiveinfo = [
  {type: 'presentingComplaint', name: '所患疾病'},
  {type: 'pastHistory', name: '既往史'},
  {type: 'familyHistory', name: '家族史'},
  {type: 'allergyHistory', name: '过敏史'},
  {type: 'diseaseDescription', name: '病情描述'}
]

export const allmedicalinfo = [
  {type: 'presentingComplaint', name: '所患疾病'},
  {type: 'pastHistory', name: '既往史'},
  {type: 'familyHistory', name: '家族史'},
  {type: 'allergyHistory', name: '过敏史'},
  {type: 'diseaseDescription', name: '病情描述'},
  {type: 'attaList', name: '图片资料'}
]

export const deptStates = [
  {0: '预约', 1: '已满', 2: '停诊', 3: '不挂号', 5: '未发布', 6: '删除'}
]

export const doctStates = [
  {0: '未排班', 1: '停诊', 2: '已满', 3: '即将放号', 4: '预约'}
]

export const shipStyle = [
  {id: 'underway', value: '配送中'},
  {id: 'received', value: '已收到'}
]

export const invoiceStyle = [
  {id: 'unpaid', value: '待支付'},
  {id: 'paid', value: '已支付'}
]

//后台所有业务中英文名称
export const BUSINESS_TYPE = {
  'PLATFORMPIC': {name:'科室咨询',},
  'VIDEO': {name:'视频咨询',},
  'ONE2ONEPIC': {name:'图文咨询',},
  'NURSE': {name:'专科护理',},
  'INTERDIAGNOSISPAY': {name:'诊间支付'},
  'INPATIENTPAY': {name:'住院预缴金'},
  'PHYSICAL_EXAMINATION': {name:'体检预约'},
  'BOOK': {name:'挂号'},
  'MEDICAL_RECORD_SEND': {name:'病历邮寄'},
  'NURSE_SERVE': {name:'专科护理服务费'},
  'NURSE_CONSUMABLE': {name:'专科护理耗材费'},
  'CONTINUATION': {name:'慢病续方'},
  'CONTINUATION_CONSULT': {name:'复诊续方'},
  'RECIPE': {name: '处方'},
  'CONTINUATION_PRESCRIPTION': {name: '慢病续方'},
  'ONLINE_OUTPATIENT': {name: '网络诊间'},
  'HIS_CONTINUATION': {name: '院内续方支付'},
  'TEAMPIC': {name: '团队咨询'},
  'TEAM': {name: '团队咨询'},
}

/**
 * 性别类型
 * @type {*[]}
 */
export const SEX_TYPE = [
  { type:'M', name:'男' },
  { type:'F', name:'女' },
]

/**
 * 证件类型
 * @type {*[]}
 */
export const CARD_TYPE = [
  { cardType:'01', cardName:'居民身份证' },
  { cardType:'02', cardName:'居民户口簿' },
  { cardType:'03', cardName:'护照' },
  { cardType:'04', cardName:'军官证' },
  { cardType:'05', cardName:'驾驶证' },
  { cardType:'06', cardName:'港澳居民来往内地通行证' },
  { cardType:'07', cardName:'台湾居民来往内地通行证' },
  { cardType:'08', cardName:'出生医学证明' },
  { cardType:'09', cardName:'医保卡' },
  { cardType:'10', cardName:'就诊卡' },
  { cardType:'11', cardName:'电子健康卡' },
  { cardType:'12', cardName:'新生儿证件' },
  { cardType:'15', cardName:'外国人永久居住证' },
  { cardType:'99', cardName:'其他法定有效证件' }
]



// WEBPACK FOOTER //
// ./src/lib/config.js